import script from "./FooterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterPage.vue?vue&type=script&setup=true&lang=js"

import "./FooterPage.vue?vue&type=style&index=0&id=c7b666ce&lang=css"

const __exports__ = script;

export default __exports__